// extracted by mini-css-extract-plugin
export default {"sectionContainer":"tenis_sectionContainer__pqwMb"};